'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordHint = void 0;
class PasswordHint {
    constructor() {
        const elms = document.querySelectorAll('.trigViewHint');
        if (!elms) {
            return;
        }
        let hint, has;
        elms.forEach((elm) => {
            elm.addEventListener('click', () => {
                hint = elm.querySelector('.bulletViewHint');
                has = hint.classList.contains('show');
                console.log(has);
                if (has) {
                    hint.classList.remove('show');
                }
                else {
                    hint.classList.add('show');
                }
            });
        });
    }
}
exports.PasswordHint = PasswordHint;
exports.default = PasswordHint;
